import { lazy } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';

// Lazy imports
const LoginPage = lazy(() => import('../auth/pages/login/LoginPage'));
const RegisterByInvitation = lazy(
  () => import('../auth/pages/register-by-invitation/RegisterByInvitation')
);
const VerificationEmail = lazy(
  () => import('../auth/pages/verification-email/VerificationEmail')
);
const EmailCodeGeneration = lazy(
  () => import('../auth/pages/email-code-generation/EmailCodeGeneration')
);
const EmailCodeVerification = lazy(
  () => import('../auth/pages/email-code-verification/EmailCodeVerification')
);

export const AuthRoutes = () => {
  return (
    <Routes>
      {/* Rutas de autenticación */}
      <Route path="login" element={<LoginPage />} />
      <Route
        path="invitation-register/:invitationCode"
        element={<RegisterByInvitation />}
      />
      <Route
        path="verification-email/:invitationCode"
        element={<VerificationEmail />}
      />
      <Route path="recover-password" element={<EmailCodeGeneration />} />
      <Route path="check-recovery-email" element={<EmailCodeVerification />} />
      {/* Ruta por defecto para /auth */}
      <Route path="*" element={<Navigate to="login" replace />} />
    </Routes>
  );
};
